import { render, staticRenderFns } from "./Params.vue?vue&type=template&id=b529e928&scoped=true"
import script from "./Params.vue?vue&type=script&lang=js"
export * from "./Params.vue?vue&type=script&lang=js"
import style0 from "./Params.vue?vue&type=style&index=0&id=b529e928&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b529e928",
  null
  
)

export default component.exports